/** @jsxImportSource react */
import { FilterButtonProps } from '@react/search/Filters/FilterButton.types';
import { Button } from '@react/system';
import cx from 'classnames';
import React, { forwardRef } from 'react';

const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  (
    {
      number: internalNumber = 0,
      selected = false,
      children,
      className,
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <Button
        ref={ref}
        onClick={onClick}
        className={cx(
          'mr-s cursor-pointer last:mr-0',
          internalNumber || selected ? 'bg-viridian-lighter-90' : 'transparent',
          'font-b-s',
          'items-center',
          'box-border',
          'h-m',
          'px-m py-0',
          className
        )}
        variant='searchFilter'
        {...props}
      >
        {internalNumber > 0 && (
          <span
            className='mr-xs h-[20px] w-[20px] rounded-[4px] bg-viridian-base text-center text-white'
            data-tp-id='gen-span-08b82fd3-3907-4e15-a0c6-c3a3b310fb08'
          >
            {internalNumber}
          </span>
        )}{' '}
        {children}
      </Button>
    );
  }
);

export default FilterButton;
